import { render } from "./IconTextbox.vue?vue&type=template&id=71060af6"
import script from "./IconTextbox.vue?vue&type=script&lang=ts"
export * from "./IconTextbox.vue?vue&type=script&lang=ts"
script.render = render

export default script